import { Typography, Button } from "antd";
import {
  FolderOutlined,
  FileOutlined,
  SearchOutlined,
} from "@ant-design/icons";

const { Title, Text } = Typography;

type EmptyStateType = "folder" | "search" | "files";

interface EmptyStateProps {
  type?: EmptyStateType;
  title?: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
}

const defaultContent: Record<EmptyStateType, { icon: React.ReactNode; title: string; description: string }> = {
  folder: {
    icon: <FolderOutlined style={{ fontSize: 64, color: "#d9d9d9" }} />,
    title: "This folder is empty",
    description: "Upload files or create subfolders to get started",
  },
  search: {
    icon: <SearchOutlined style={{ fontSize: 64, color: "#d9d9d9" }} />,
    title: "No results found",
    description: "Try adjusting your search terms",
  },
  files: {
    icon: <FileOutlined style={{ fontSize: 64, color: "#d9d9d9" }} />,
    title: "No files yet",
    description: "Upload your first file to get started",
  },
};

export default function EmptyState({
  type = "folder",
  title,
  description,
  actionLabel,
  onAction,
}: EmptyStateProps) {
  const content = defaultContent[type];

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "64px 24px",
        textAlign: "center",
      }}
    >
      {content.icon}
      <Title
        level={4}
        style={{
          marginTop: 24,
          marginBottom: 8,
          color: "#595959",
          fontWeight: 500,
        }}
      >
        {title || content.title}
      </Title>
      <Text
        type="secondary"
        style={{
          display: "block",
          marginBottom: actionLabel ? 24 : 0,
        }}
      >
        {description || content.description}
      </Text>
      {actionLabel && onAction && (
        <Button type="primary" size="large" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
